import {
  buildContentHubPublishedVideoDeepLink,
  buildContentHubSharePageUrl,
} from "./build-content-hub-share-page-url";
import { copyVideoSharePageUrlAndShowToast } from "./video-share-copied-toast";

/**
 * Copies the share URL derived from the current address bar (query preserved on
 * the canonical hub origin). Used by the in-player Share control on **published**
 * and **preview** hub pages; {@link writeVideoShareUrl} still runs only on published
 * routes so the preview URL bar stays stable.
 */
export async function copyContentHubBrowserVideoShareLink(params: {
  organizationExternalId?: string | null;
  pageSlug?: string | null;
}): Promise<void> {
  await copyVideoSharePageUrlAndShowToast(buildContentHubSharePageUrl(params));
}

/**
 * Copies a **published-style** deep link (`videoId`, `sectionId`, optional `videoName`)
 * for the video card that opened the player, so shared URLs open and auto-play on
 * the hub even when the address bar was never synced. Falls back to
 * {@link copyContentHubBrowserVideoShareLink} if `sectionId` cannot be resolved.
 */
export async function copyContentHubInPlayerVideoShareDeepLink(params: {
  organizationExternalId?: string | null;
  pageSlug?: string | null;
  pageUrl?: string | null;
  getVideoCardElement: () => HTMLElement | null | undefined;
  videoId: string;
  videoName?: string | null;
}): Promise<void> {
  const deepLink = buildContentHubPublishedVideoDeepLink({
    organizationExternalId: params.organizationExternalId,
    pageSlug: params.pageSlug,
    pageUrl: params.pageUrl ?? null,
    getSectionRootElement: params.getVideoCardElement,
    videoId: params.videoId,
    videoName: params.videoName,
  });

  if (deepLink) {
    await copyVideoSharePageUrlAndShowToast(deepLink);
    return;
  }

  await copyContentHubBrowserVideoShareLink({
    organizationExternalId: params.organizationExternalId,
    pageSlug: params.pageSlug,
  });
}
